import styled, { css } from 'styled-components';

export const ListViewContainer = styled.div`
  width: 100%;
  height: calc(100% - 40px);
`;

export const Container = styled.div`
  width: 100%;
  height: calc(100% - 32px);
`;

export const HeaderContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 24px;
`;

export const PageContainer = styled.div`
  width: 100%;
  height: 100%;

  position: relative;
  padding-top: 104px;

  display: flex;
  flex-direction: column;
`;

export const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
  max-height: 100%;
  display: flex;

  justify-content: center;

  ${({ isFooterDisplayed }) =>
    isFooterDisplayed &&
    css`
      height: calc(100% - 56px);
    `};
`;

export const ButtonsContainer = styled.div`
  width: 100%;

  display: flex;
  justify-content: end;
  gap: 16px;
`;

export const ModalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalDropdownItem = styled.div`
  width: 100%;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
`;
